var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopBar'),_c('router-view'),(_vm.isRouterAlive)?_c('Footer',{attrs:{"v":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }